/* eslint-disable no-nested-ternary */
import { Flex } from '@chakra-ui/react';
import {
  useGetDisciplinaryActionsNotesCountChartData,
  useGetDisciplinaryActionsNotesStageChartData,
} from 'Deer/pages/MyData/DisciplinaryActions/dataHooks';
import { useSelectedView } from 'reducers/viewsSlice';

import { DISCIPLINARY_ACTIONS_GRAPH_TYPES } from 'constants/ProjectConstants';

import DisciplinaryActionsChartContainer from './DisciplinaryActionsChartContainer';
import { ChartLoading, ChartErrorScreen } from './GraphLoadingSections';

const GRAPH_TYPES = {
  BAR: 'BAR',
};

const DisciplinaryActionsGraphSection = () => {
  const cohortDetails = useSelectedView();
  const {
    isFetching: isFetchingNotesCountChartData,
    data: notesCountChartData,
    error: notesCountChartDataError,
  } = useGetDisciplinaryActionsNotesCountChartData({
    cohortId: cohortDetails?.id,
    graphType: GRAPH_TYPES.BAR,
    reportType: DISCIPLINARY_ACTIONS_GRAPH_TYPES.DISCIPLINARY_ACTION_NOTES,
  });

  const {
    isFetching: isFetchingNotesStatusChartData,
    data: notesStatusChartData,
    error: notesStatusChartDataError,
  } = useGetDisciplinaryActionsNotesStageChartData({
    cohortId: cohortDetails?.id,
    graphType: GRAPH_TYPES.BAR,
    reportType: DISCIPLINARY_ACTIONS_GRAPH_TYPES.DISCIPLINARY_ACTION_NOTES_STAGE_BREAKUP,
  });

  const charts = [
    {
      isFetching: isFetchingNotesCountChartData,
      error: notesCountChartDataError,
      data: notesCountChartData,
      title: 'Trend of disciplinary notes',
      reportType: DISCIPLINARY_ACTIONS_GRAPH_TYPES.DISCIPLINARY_ACTION_NOTES,
    },
    {
      isFetching: isFetchingNotesStatusChartData,
      error: notesStatusChartDataError,
      data: notesStatusChartData,
      title: 'Disciplinary notes stage breakup',
      reportType: DISCIPLINARY_ACTIONS_GRAPH_TYPES.DISCIPLINARY_ACTION_NOTES_STAGE_BREAKUP,
    },
  ];

  return (
    <Flex gap={4} h="348px">
      {charts.map((chart) => {
        const { isFetching, error, data, title, reportType } = chart;
        return isFetching ? (
          <ChartLoading />
        ) : error ? (
          <ChartErrorScreen />
        ) : data ? (
          <DisciplinaryActionsChartContainer title={title} data={data?.entity?.metrics ?? []} reportType={reportType} />
        ) : null;
      })}
    </Flex>
  );
};

export default DisciplinaryActionsGraphSection;
